import { LovesSandboxApiServer } from './loves_sandbox_api_server.js';

export function name(apiServer: LovesSandboxApiServer): string {
  switch (apiServer) {
    case LovesSandboxApiServer.Dev:
      return 'Development';
    case LovesSandboxApiServer.Qa:
      return 'QA';
  }
}
